import { loginreq, req } from './axiosFun';


/**
 *
 * 用户管理
 *
 * */

//返回所有负责人
export const get_department = (params) => { return req("post", " /api/get_department", params) };
// 添加负责人
export const create_department = (params) => { return req("post", " /api/create_department", params) };
//修改负责人
export const mod_department = (params) => { return req("post", " /api/mod_department", params) };
//删除负责人  需要先删除关联的所有项目信息，否则不能删除
export const del_department = (params) => { return req("post", " /api/del_department", params) };


/**
 *
 * 项目管理
 *
 * */

//获取所有项目
// export const get_projectt = (params) => { return req("post", " /api/get_project", params) };
//删除项目
export const del_project = (params) => { return req("post", "/api/del_project", params) };
//创建项目
export const create_project = (params) => { return req("post", "/api/create_project", params) };
//修改项目
export const mod_project = (params) => { return req("post", "/api/mod_project", params) };
//查询回款计划
export const get_collection_plan = (params) => { return req("post", "/api/get_collection_plan", params) };
//修改回款计划
export const mod_collection_plan = (params) => { return req("post", "/api/mod_collection_plan", params) };
//删除回款计划
export const del_collection_plan = (params) => { return req("post", "/api/del_collection_plan", params) };
//添加回款计划
export const create_collection_plan = (params) => { return req("post", "/api/create_collection_plan", params) };
//添加实际回款
export const create_collection_actual = (params) => { return req("post", "/api/create_collection_actual", params) };
//查询实际回款
export const get_collection_actual = (params) => { return req("post", "/api/get_collection_actual", params) };
//修改实际回款
export const mod_collection_actual = (params) => { return req("post", "/api/mod_collection_actual", params) };
//删除实际回款
export const del_collection_actual = (params) => { return req("post", "/api/del_collection_actual", params) };
//查询开票时间
export const get_billing = (params) => { return req("post", "/api/get_billing", params) };
//修改开票时间
export const mod_billing = (params) => { return req("post", "/api/mod_billing", params) };
//删除开票时间
export const del_billing = (params) => { return req("post", "/api/del_billing", params) };
//新增开票时间
export const create_billing = (params) => { return req("post", "/api/create_billing", params) };
//查询项目
export const filter = (params) => { return req("post", "/api/filter", params) };
//获取单个项目
export const get_project = (params) => { return req("post", "/api/get_project", params) };



/**
 *
 * 部门管理
 *
 * */
//获取所有部门
export const get_departments = (params) => { return req("post", "/api/get_departments", params) };
//增加部门
export const create_departments = (params) => { return req("post", "/api/create_departments", params) };
//修改部门
export const mod_departments = (params) => { return req("post", "/api/mod_departments", params) };
//删除部门
export const del_departments = (params) => { return req("post", "/api/del_departments", params) };
//部门详情
export const performance = (params) => { return req("post", "/api/performance", params) };
//增加每月成本
export const create_depart_cost = (params) => { return req("post", "/api/create_depart_cost", params) };
//删除每月成本
export const get_depart_cost = (params) => { return req("post", "/api/get_depart_cost", params) };
//修改每月成本
export const mod_depart_cost = (params) => { return req("post", "/api/mod_depart_cost", params) };
//详情-获取部门成本
export const del_depart_cost  = (params) => { return req("post", "/api/del_depart_cost ", params) };



/**
 *
 * 数据统计
 *
 * */
//部门分析
export const statistics = (params) => { return req("post", "/api/statistics", params) };
//经营销量分析
export const efficiency = (params) => { return req("post", "/api/efficiency", params) };


//经营销量分析 ---- 导出
export const getefficiency = (params) => { return req("get", "/api/efficiency", params) };




// WEBPACK FOOTER //
// ./src/api/user.js